module.exports = __webpack_public_path__ + "static/media/add1-white.58458ad3.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/add1-white.svg
// module id = 6216
// module chunks = 0